import {
  type ContextType,
  type FC,
  type PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

type PaginationContextValue = {
  pageNumber: number;
  setPageNumber: (pageNumber: number) => void;
};

const Context = createContext<PaginationContextValue | undefined>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('usePagination must be used within a PaginationProvider.');
  }
  return context;
};

export const usePaginationState = () => {
  return _useContext();
};

export const NestedTablePaginationProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [pageNumber, setPageNumber] = useState<number>(1);

  return (
    <Context.Provider value={{ pageNumber, setPageNumber }}>
      {children}
    </Context.Provider>
  );
};
